'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HocCreator = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal = require('../../components/modal');

var _dataSet = require('../../components/dataSet');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HocCreator = exports.HocCreator = function () {
  function HocCreator() {
    _classCallCheck(this, HocCreator);

    this._modals = [];
  }

  _createClass(HocCreator, [{
    key: 'getModalComponent',


    /**
     * modalOption = {
     *  // 对话框的配置
     *  modalProps,
     *  // 对话框打开类型
     *  modalType,
     *  // 独立打开
     *  standalone,
     *  // 子组件的属性
     *  childProps
     * }
     */
    value: function getModalComponent(Widget, modalOption, richProps) {
      var modalType = modalOption.modalType || 'open';
      // 有richProps说明是一个动态数据的组件
      if (richProps) {
        Widget = this.getRichComponent(Widget, richProps);
      }
      var option = Object.assign({
        content: _react2.default.createElement(Widget, modalOption.childProps)
      }, modalOption.modalProps);

      var modal = _modal.GModal[modalType](option);

      // 多个对话框可以叠加
      if (modalOption.standalone) {
        this._modals.push(modal);
      } else {
        // 否则把之前的对话框干掉，只显示当前的
        this._modals[0] && this._modals[0].destroy();
        this._modals[0] = modal;
      }
      return modal;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var modal = this._modals.pop();
      modal && modal.destroy();
    }
  }, {
    key: 'getRichComponent',
    value: function getRichComponent(Widget, richProps) {
      var RichWidget = function (_React$PureComponent) {
        _inherits(RichWidget, _React$PureComponent);

        function RichWidget() {
          _classCallCheck(this, RichWidget);

          return _possibleConstructorReturn(this, (RichWidget.__proto__ || Object.getPrototypeOf(RichWidget)).apply(this, arguments));
        }

        _createClass(RichWidget, [{
          key: 'getRealInstance',
          value: function getRealInstance() {
            return this._wrappedComponent;
          }
        }, {
          key: 'handleResolve',
          value: function handleResolve(v, params) {
            this._wrappedComponent.handleResolve(v, params);
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            if (richProps.childProps) {
              Object.assign(richProps.childProps, this.props);
            }
            return _react2.default.createElement(
              _dataSet.DataSet,
              _extends({
                ref: function ref(inst) {
                  return _this2._wrappedComponent = inst;
                }
              }, richProps),
              _react2.default.createElement(Widget, null)
            );
          }
        }]);

        return RichWidget;
      }(_react2.default.PureComponent);

      return RichWidget;
    }
  }]);

  return HocCreator;
}();


//////////////////
// WEBPACK FOOTER
// ./src/services/hocCreator/index.js
// module id = 126
// module chunks = 0